import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../app/api-client';

export interface ObserverScope {
  roleCode: string;
  displayName: string;
  description: string;
  medicineTags: string[];
  registrarKinds: string[];
  scoped: boolean;
  noAccess: boolean;
}

/**
 * UC61-02 — the data scope the session's observer role is restricted to. Read
 * by the scope banner and by the sidebar account block (which names the
 * observer's institution); one query key, one fetch.
 */
export function useObserverScope(role: string | undefined): {
  scope: ObserverScope | undefined;
} {
  const q = useQuery({
    queryKey: ['observer-scope', role],
    queryFn: () => apiClient.get<ObserverScope>('/observer-scope').then((r) => r.data),
    enabled: role !== undefined && role.startsWith('OBSERVER'),
    staleTime: 60_000,
  });
  return { scope: q.data };
}
